import http from 'plugins/axios';

export default {
  getList({descCode, chinese, page, size}){
    return http.post({
      url:'/la/admin/internationalization/list',
      data:{
        descCode, chinese, page, size
      }
    })
  },
  // getCodeList({page,size,zh}) {
  //   return http.post({
  //     url: `/la/admin/countryCode/list?page=${page}&size=${size}`,
  //     data:{
  //       zh
  //     }
  //     // dataType: 'form'
  //   });
  // },

  delOne(id) {
    return http.delete({
      url: `/la/admin/internationalization/delete/`+id ,
    });
  },
  addOne(data) {
    return http.post({
      url: '/la/admin/internationalization/add',
      data,
    });
  },
  updateCode(id,data) {
    return http.put({
      url: '/la/admin/internationalization/update/'+id,
      data,
    });
  },
};
